import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "agreement" }
const _hoisted_2 = { class: "agreement_nei" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = ["innerHTML"]

import { onMounted, ref } from "vue";
import { Axios } from "../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
import leftTemplate4 from "@/components/leftTemplate4.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'agreement',
  setup(__props) {

const ccc = ref('')
const cccContent = ref('')
onMounted(() => {
  ccc.value = decodeURI(window.location.href.split('=')[1])
  init()
})
const init = () => {
  Axios("get", `/system/notice/bycode/${ccc.value}`, {}, false, function (res) {
    if (res.data.code == 200) {
      cccContent.value = res.data.data.noticeContent
    } else {
      ElMessage.error(res.data.message);
    }
  });
}
const back = (val) => {
  ccc.value = val
  init()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate4, {
          left_tabShow: ccc.value,
          onBack: back
        }, null, 8, ["left_tabShow"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", { innerHTML: cccContent.value }, null, 8, _hoisted_5)
      ])
    ])
  ]))
}
}

})